export default function isActive ({ next, store }){
   if(!store.getters.getUser.is_active){
      // return next();
      return next({
        name: 'AccountDeactivated'
      })
   } else {
      return next()
   }
}